import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";

const SendEmailModal = ({ title, show, handleClose, handleSend }) => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [name, setName] = useState("");
  const [isMobile, setIsMobile] = useState(false);

  // Detect screen size for mobile optimization
  useEffect(() => {
    const checkScreenSize = () => setIsMobile(window.innerWidth < 576);
    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);
    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  const resetForm = () => {
    setEmail("");
    setName("");
    setMessage("");
  };

  const onSend = () => {
    handleSend(name, email, message);
    resetForm();
    handleClose();
  };

  return (
    <Modal
      show={show}
      onHide={() => {
        resetForm();
        handleClose();
      }}
      centered
      fullscreen={isMobile}
      size="md"
      aria-labelledby="send-email-modal"
    >
      <Modal.Header closeButton className="bg-dark text-light">
        <Modal.Title id="send-email-modal">
          📩 Send Email {title && `- ${title}`}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className="bg-light">
        <p>🙏 Please enter the recipient's name and email address:</p>

        <Form>
          <Form.Group className="mb-3" controlId="emailName">
            <Form.Label>Name</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter Name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              style={{ fontSize: "1rem", padding: "10px" }}
              required
            />
          </Form.Group>

          <Form.Group className="mb-3" controlId="emailAddress">
            <Form.Label>Email</Form.Label>
            <Form.Control
              type="email"
              placeholder="Enter email address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              style={{ fontSize: "1rem", padding: "10px" }}
              required
            />
          </Form.Group>

          <Form.Group className="mb-3" controlId="emailMessage">
            <Form.Label>Message (Optional)</Form.Label>
            <Form.Control
              as="textarea"
              rows={4}
              placeholder="Optional message"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              style={{ fontSize: "1rem", padding: "10px" }}
            />
          </Form.Group>
        </Form>
      </Modal.Body>

      <Modal.Footer className="bg-light">
        <Button
          variant="secondary"
          onClick={() => {
            resetForm();
            handleClose();
          }}
        >
          Cancel
        </Button>

        <Button
          variant="primary"
          onClick={onSend}
          disabled={!email.trim()}
        >
          Send
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default SendEmailModal;
